// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindClassification } from "../schema";

export function serialize_KindClassification_internal(value: KindClassification): unknown {
  return ((value: "classification"): unknown => {
    return value;
  })(value);
}
export function serialize_KindClassification(obj: KindClassification): string {
  return renderJsonWithNumbersAsBigint(serialize_KindClassification_internal(obj));
}
export function deserialize_KindClassification_internal(value: unknown): ParserResult<KindClassification> {
  return ((value: unknown): ParserResult<"classification"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "classification":
        return { success: true, value: "classification" };
      default:
        return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
    }
  })(value);
}
export function deserialize_KindClassification(str: string): ParserResult<KindClassification> {
  return deserialize_KindClassification_internal(parseJsonWithNumbersAsBigint(str));
}
